import { ReactComponent as ChevronLeft } from 'assets/icons/icon-chevron-left.svg';

export default ChevronLeft;
